import * as v from 'valibot';

import { HTTPError } from './fetcher';

const nullableString = v.nullish(v.string());

const apiErrorSchema = v.object({
  errors: v.nullish(
    v.array(
      v.object({
        code: nullableString,
        description: nullableString,
        message: nullableString,
        target: nullableString,
        type: nullableString,
      }),
    ),
  ),
});

export const getApiErrorMessage = async (error: unknown): Promise<string | undefined> => {
  if (!(error instanceof HTTPError)) {
    return undefined;
  }

  try {
    const { errors } = v.parse(apiErrorSchema, await error.response.clone().json());

    return (
      errors
        ?.map(({ description, message }) => message || description)
        .filter(Boolean)
        .join('. ') || undefined
    );
  } catch {
    return undefined;
  }
};
